

const url = "/services/"

var subservices = {
  "Advanced penetration testing" : [
    { title : "Web application security assessment", path:url},
    { title : "Mobile app security assessment", path:url},
    { title : "Network security assessment", path:url},
    { title : "Cloud security assessment", path:url},
    { title : "API security assessment", path:url},
    { title : "Infrastructure security assessment", path:url},
    { title : "Thick client Security assessment", path:url},
  ],
  "Compliance management" : [
    {title : "ISO 27001 & ISO 27002", path:url},
    {title : "PCI DSS", path:url},
    {title : "HIPAA", path:url},
    {title : "SOC 2", path:url},
    {title : "GDPR", path:url},
  ],
  "Services & support" : [
    {title : "Secure source code review", path:url},
    {title : "Cyber intelligence assessment", path:url},
    {title : "Cyber security consultancy", path:url},
  ],
  "Solutions" : [
    {title : "Virtual cyber security team", path:url},
    {title : "Incident response", path:url},
    {title : "Managed SOC", path:url},
  ],
}

   
    //Change path of subservices
     
Object.keys(subservices).map(key=>{
    return subservices[key] = subservices[key].map(service=>{
        var serviceTitle = service.title.toLowerCase();
        service.path = service.path + serviceTitle.split(' ').join('-');
        return service;
    })
})

export default subservices;